"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsMenu = void 0;
var React = __importStar(require("react"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Menu_1 = __importDefault(require("@material-ui/core/Menu"));
var icons_1 = require("@epic-ui/icons");
var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));
var withStyles_1 = __importDefault(require("@material-ui/core/styles/withStyles"));
var styles = function (_a) {
    var spacing = _a.spacing;
    return createStyles_1.default({
        paper: {
            transform: "translate(1px, -1px)",
            minWidth: spacing(34),
        },
    });
};
exports.OptionsMenu = withStyles_1.default(styles)(React.forwardRef(function OptionsMenu(_a, ref) {
    var onClose = _a.onClose, childrenProp = _a.children, keepOpen = _a.keepOpen, _b = _a.MenuListProps, MenuListProps = _b === void 0 ? {} : _b, openLabel = _a.openLabel, _c = _a.openButtonProps, _d = _c === void 0 ? {} : _c, onClickOpen = _d.onClick, openButtonProps = __rest(_d, ["onClick"]), props = __rest(_a, ["onClose", "children", "keepOpen", "MenuListProps", "openLabel", "openButtonProps"]);
    var _e = React.useState(false), open = _e[0], setOpen = _e[1];
    var triggerRef = React.useRef(null);
    var handleClose = React.useCallback(function (event, reason) {
        if (reason === void 0) { reason = "backdropClick"; }
        onClose && onClose(event, reason);
        setOpen(false);
    }, [onClose]);
    var handleClickOpen = React.useCallback(function (event) {
        setOpen(true);
        onClickOpen && onClickOpen(event);
    }, [onClickOpen]);
    var positionProps = React.useMemo(function () { return ({
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "right",
        },
    }); }, []);
    // Manages closing menu on clicking item
    var children = keepOpen
        ? childrenProp
        : React.Children.map(childrenProp, function (child) {
            return React.isValidElement(child)
                ? React.cloneElement(child, {
                    onClick: function (event) {
                        child.props.onClick && child.props.onClick(event);
                        handleClose(event);
                    },
                })
                : child;
        });
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton_1.default, __assign({ "aria-haspopup": "true", "aria-expanded": open ? "true" : undefined, "aria-label": openLabel, ref: triggerRef, onClick: handleClickOpen }, openButtonProps),
            React.createElement(icons_1.More, null)),
        React.createElement(Menu_1.default, __assign({ anchorEl: triggerRef.current, open: open, onClose: handleClose, MenuListProps: __assign({}, MenuListProps) }, positionProps, props, { ref: ref }), children)));
}));
//# sourceMappingURL=OptionsMenu.js.map